import React from 'react';
import styles from './editOrganisationMap.module.scss';
import { EditPageModals } from './editOrganisationMap.util';
import { FormikProps } from 'formik';
import { OrganisationMapPayload } from 'models/CompanySetup/organisationPayload.model';
import { MetaData } from 'models/MetaData/metaData.model';
import { deepClone } from 'shared/utils/deepCopy.util';

export const getResetModalConfig = (
  openModalType: EditPageModals | undefined,
  closeModals: () => void
) => {
  return {
    showModal: openModalType === EditPageModals.RESET_MODAL,
    onCancel: closeModals,
    confirmButtonText: 'Reset',
    cancelButtonText: 'Back',
    confirmationText: 'Are you sure you want to reset the changes?',
    confirmationClassName: styles.confirmationModalContent,
    width: 450,
    subInfo: (
      <div className={styles.confirmationSubInfo}>
        Changes done in this year will be reset
      </div>
    ),
  };
};

export const handleSubmitUtil = async (
  values: { year?: string } | undefined,
  isYearModalOpen: boolean,
  createOrganisationMap: (year: number) => Promise<true | undefined>,
  fetchOrganisationMap: (
    params: { year: number },
    force?: boolean
  ) => Promise<OrganisationMapPayload | undefined>,
  setActiveYear: React.Dispatch<React.SetStateAction<string>>,
  setParams: (params: Record<string, string | number>) => void,
  handleCloseModal: () => void,
  formRef: React.RefObject<FormikProps<OrganisationMapPayload>>,
  setOrganisationMapData: React.Dispatch<
    React.SetStateAction<OrganisationMapPayload>
  >
) => {
  if (!values?.year) return;

  if (isYearModalOpen) {
    const response = await createOrganisationMap(Number(values.year));
    if (!response) return;

    setActiveYear(values.year.toString());
    setParams({ year: values.year });
    handleCloseModal();
  } else {
    const response = await fetchOrganisationMap(
      { year: Number(values.year) },
      true
    );
    if (!response) return;

    formRef.current?.setFieldValue('organizationMap', response.organizationMap);
    setOrganisationMapData(prev => ({
      ...prev,
      organizationMap: response.organizationMap,
    }));
    handleCloseModal();
  }
};
